// Static UI string dictionary (English + Hebrew) and content localization helper.

export const STRINGS = {
  en: {
    // Navbar
    "nav.home": "Home",
    "nav.programs": "Programs",
    "nav.events": "Events",
    "nav.holidays": "Holidays",
    "nav.about": "About",
    "nav.gallery": "Gallery",
    "nav.services": "Services",
    "nav.contact": "Contact",
    "nav.donate": "Donate",

    // Hero
    "hero.eyebrow": "Prague · Est. Community",
    "hero.title1": "A warm home",
    "hero.title2a": "for every",
    "hero.title2b": "Jewish",
    "hero.title3": "heart in Prague",
    "hero.subtitle": "From children's programs and Bar/Bat Mitzvah to Shabbat meals, holidays, teens, and our students club — join a community built on warmth, tradition, and joy.",
    "hero.explore": "Explore Programs",
    "hero.support": "Upcoming Events",
    "hero.about": "About Us",
    "hero.programs": "Our Programs",
    "hero.imgcap1": "Prague · From Above",
    "hero.imgcap2": "Where our story continues",
    "hero.scroll": "Scroll",
    "hero.badge": "A warm home since 1996",

    // Programs
    "programs.eyebrow": "Our Programs",
    "programs.title": "Something for every stage of life",
    "programs.desc": "Six pillars of community life, each designed to nurture connection, learning, and belonging.",

    // Holiday box
    "holiday.eyebrow": "Upcoming Holiday",
    "holiday.now_eyebrow": "Happening now",
    "holiday.now": "Now",
    "holiday.in_prefix": "In",
    "holiday.day": "day",
    "holiday.days": "days",
    "holiday.explore": "Explore the holiday",

    // Stats
    "stats.eyebrow": "By the Numbers",
    "stats.title": "A community that grows warmer every year",

    // Events
    "events.eyebrow": "What's On",
    "events.title": "Upcoming events",
    "events.desc": "Join us for Shabbat dinners, holiday celebrations, and community gatherings.",
    "events.viewall": "View all events",
    "events.empty": "No upcoming events right now — check back soon.",

    // Donate
    "donate.eyebrow": "Support the Community",
    "donate.title1": "Your gift keeps our doors",
    "donate.title_italic": "open",
    "donate.desc": "Every donation fuels Shabbat meals, children's education, holiday celebrations, and support for students far from home. In Jewish tradition, gifts of chai (18) carry a blessing of life.",
    "donate.heart": "100% goes directly to community programs",
    "donate.onetime": "One-time",
    "donate.monthly": "Monthly",
    "donate.other": "Other",
    "donate.name_ph": "Your name (optional)",
    "donate.email_ph": "Your email (optional)",
    "donate.button": "Donate",
    "donate.permonth": "/mo",
    "donate.redirecting": "Redirecting…",
    "donate.secure": "Secure payment · Stripe & PayPal",
    "donate.secure_stripe": "Secure payment via Stripe",
    "donate.card": "Pay with card",
    "donate.paypal": "Pay with PayPal",
    "donate.or": "or",
    "donate.paypal_monthly_note": "PayPal is for one-time gifts. Please use card for monthly giving.",
    "donate.err_amount": "Please choose a donation amount",
    "donate.err_checkout": "Could not start checkout",

    // Gallery
    "gallery.eyebrow": "Moments",
    "gallery.title": "Life at the Hub",
    "gallery.desc": "A glimpse into the celebrations, learning, and friendships that make us a family.",

    // Contact
    "contact.eyebrow": "Get in Touch",
    "contact.title": "We'd love to hear from you",
    "contact.desc": "Questions about a program, want to host a Shabbat, or just say hello? Reach out — our door is always open.",
    "contact.address": "Old Town, Prague, Czech Republic",
    "contact.whatsapp": "420724300120",
    "contact.whatsapp_cta": "Click to message us",
    "contact.email": "hello@chabadprague.cz",
    "contact.phone": "+420 000 000 000",
    "contact.name": "Name",
    "contact.email": "Email",
    "contact.subject": "Subject",
    "contact.message": "Message",
    "contact.send": "Send Message",
    "contact.sending": "Sending…",
    "contact.success": "Message sent! We'll be in touch soon.",
    "contact.error": "Could not send message",

    // Weekly strip
    "weekly.eyebrow": "Every Week",
    "weekly.title": "A place to learn, pray & belong",
    "weekly.readmore": "Read more & join",
    "weekly.ourshul": "Our Shul",
    "services.eyebrow": "Community Services",
    "services.title": "Here for your everyday needs",
    "services.desc": "Beyond our programs — the services that support Jewish life in Prague, from kosher food to our synagogue.",
    "services.serves": "Community service",
    "services.viewall": "View all services",
    "services.order_whatsapp": "Order via WhatsApp",
    "services.contact_whatsapp": "Contact us for more info",
    "library.donate_title": "Donate a book, grow the library",
    "library.donate_desc": "Have a Jewish children's book to share? Your gift helps our shelves — and our young readers — grow.",
    "library.donate_cta": "Donate a book via WhatsApp",
    "library.donate_msg": "Hi! I'd like to donate a children's book to the library.",
    "services.empty": "Services will appear here soon.",
    "kosher_estab.eyebrow": "Kosher Dining",
    "kosher_estab.title": "Kosher Establishments",
    "kosher_estab.desc": "",
    "kosher_estab.address": "Address",
    "kosher_estab.hours": "Opening hours",
    "kosher_estab.reserve": "Reservations",
    "kosher_estab.group": "Group bookings",
    "kosher_estab.map": "View on map",
    "tourist.eyebrow": "Tourist Desk",
    "tourist.title": "Tourist Desk",
    "tourist.desc": "",
    "tourist.nolink": "The tourist website link hasn't been added yet.",
    "tourist.provide": "What we help with",
    "tourist.f1": "Shabbat meals",
    "tourist.f2": "Tourist WhatsApp assistance",
    "tourist.f3": "Tour guide & hotel recommendations",
    "tourist.f4": "Synagogue",
    "tourist.f5": "Kosher restaurants & shop",
    "tourist.f6": "Emergency help",
    "shul.prayer_times": "Prayer times",
    "shul.weekday": "Weekdays",
    "shul.shabbat": "Shabbat & holidays",

    // Footer
    "footer.tagline": "A warm, welcoming home for Jewish life in the heart of Prague.",
    "footer.explore": "Explore",
    "footer.about": "About Us",
    "footer.support": "Support",
    "footer.admin": "Admin",
    "footer.visit": "Visit us",
    "footer.address": "Old Town, Prague",
    "footer.country": "Czech Republic",
    "footer.rights": "All rights reserved.",
    "footer.built": "Built with warmth · Prague",

    // Events page
    "eventspage.eyebrow": "Event Calendar",
    "eventspage.title": "What's happening",
    "eventspage.desc": "Join us. There's always a seat at our table.",
    "eventspage.filter": "Filter:",
    "eventspage.all": "All Events",
    "eventspage.none_title": "No events found",
    "eventspage.none_desc": "Try adjusting your filters or check back soon.",

    // Event detail
    "eventdetail.back": "All events",
    "eventdetail.past_title": "This event has already taken place",
    "eventdetail.past_desc": "RSVPs are closed. Browse our upcoming events to join us next time.",
    "eventdetail.rsvp_closed_title": "Reservations are closed",
    "eventdetail.sold_out_title": "Fully booked",
    "card.sold_out": "Fully booked",
    "eventdetail.notfound": "Event not found",
    "eventdetail.backto": "Back to events",
    "eventdetail.loading": "Loading…",
    "eventdetail.time_tba": "Time TBA",
    "eventdetail.default_loc": "Chabad of Prague",
    "eventdetail.community": "Community",
    "eventdetail.loc_rsvp": "Location shared upon RSVP",
    "eventdetail.about": "About this event",
    "eventdetail.rsvp_direct": "RSVP directly",
    "eventdetail.rsvp_direct_desc": "To reserve your spot for this event, please message us directly on WhatsApp — we'll confirm your place and share any details.",
    "eventdetail.rsvp_wa": "RSVP on WhatsApp",
    "eventdetail.no_rsvp_title": "No reservation necessary — all are welcome!",
    "eventdetail.no_rsvp_desc": "Message us on WhatsApp if you have any questions or for more info.",
    "eventdetail.no_rsvp_wa": "Contact us on WhatsApp",
    "card.no_rsvp": "No RSVP needed",
    "card.students_only": "Students only",
    "eventdetail.students_title": "For students only",
    "eventdetail.students_desc": "This event is open to students only. Message us on WhatsApp and we'll send you the private access link.",
    "eventdetail.students_wa": "Contact us on WhatsApp",
    "card.students_cta": "Contact us for the link →",

    // Event card
    "card.view_rsvp": "View & RSVP",
    "card.view": "View details",

    // RSVP form
    "rsvp.title": "Reserve your spot",
    "rsvp.fullname": "Full name",
    "rsvp.email": "Email",
    "rsvp.phone": "Phone (optional)",
    "rsvp.guests": "Guests",
    "rsvp.adults": "Adults",
    "rsvp.children": "Children",
    "rsvp.each": "each",
    "rsvp.confirm": "Confirm RSVP",
    "rsvp.confirming": "Confirming…",
    "rsvp.done_title": "You're all set!",
    "rsvp.done_desc": "A confirmation email is on its way. We can't wait to see you.",
    "rsvp.success": "RSVP confirmed! Check your email.",
    "rsvp.error": "Could not submit RSVP",
    "rsvp.required": "Please fill this out",
    "rsvp.check_form": "Please complete the highlighted fields",
    "rsvp.per_person": "Per person",
    "rsvp.family": "Family (flat rate)",
    "rsvp.ticket": "Ticket",
    "rsvp.total": "Total",
    "rsvp.pay": "Pay",
    "rsvp.pay_rsvp": "& RSVP",
    "rsvp.paywait": "Confirming your payment…",
    "rsvp.paid_toast": "Payment received — you're confirmed! Check your email.",
    "rsvp.pay_error": "Payment could not be verified. Please contact us.",
    "rsvp.pending_title": "Thank you — you're on the list!",
    "rsvp.pending_desc": "Your RSVP is pending approval. We'll email you as soon as it's confirmed.",
    "rsvp.pending_toast": "RSVP received — pending approval.",
    "rsvp.paid_pending_title": "Card authorized ✓",
    "rsvp.paid_pending_desc": "Thank you! Your card was authorized but not charged. Your RSVP is now pending approval — you'll only be charged once it's confirmed, and we'll email you.",
    "rsvp.paid_pending_toast": "Card authorized — you'll be charged only once your RSVP is approved.",
    "rsvp.select_ph": "Select…",
    "rsvp.pay_card": "Pay with card",
    "rsvp.paypal": "Pay with PayPal",

    // Program detail
    "program.back": "All programs",
    "program.label": "Program",
    "program.notfound": "Program not found",
    "program.backhome": "Back home",
    "program.explore_within": "Explore within",
    "program.sub_active": "Active",
    "program.sub_inactive": "Inactive",
    "program.sub_next": "Next",
    "program.sub_view_event": "View event",
    "wa.title": "Join our community",
    "wa.cta": "Join",
    "wa.desc": "Get event updates and stay connected on WhatsApp.",
    "wa.btn": "Join the WhatsApp group",
    "program.upcoming": "Upcoming",
    "program.upcoming_suffix": "events",
    "program.events_empty": "No upcoming events in this program right now — check back soon.",
    "program.past_events": "Past events",
    "program.past_events_hide": "Hide past events",
    "program.past_events_empty": "No past events yet.",
    "program.memories": "Memories",
    "program.flyers_eyebrow": "Good to know",
    "program.flyers_title": "Flyers & info",
    "program.past_photos": "Photos from past events",
    "program.interested": "Interested in",
    "program.interested_q": "?",
    "program.cta_desc": "We'd love to welcome you. Reach out and we'll help you get involved.",
    "program.get_in_touch": "Get in Touch",
    "program.stay_updated": "Stay updated on WhatsApp",

    // Students Club sign-up
    "student.signup_title": "New in town? Come say hi",
    "student.signup_desc": "Studying in Prague? Join the Students Club — dinners, trips, and good people. Drop your details and we'll be in touch.",
    "student.signup_btn": "Sign me up",
    "student.form_title": "Join the Students Club",
    "student.form_intro": "Just a few quick things so we can get to know you and keep you in the loop.",
    "student.name": "Your name",
    "student.name_ph": "First and last name",
    "student.whatsapp": "WhatsApp number",
    "student.whatsapp_ph": "So we can add you to the group",
    "student.faculty": "What are you studying?",
    "student.faculty_ph": "Faculty / university",
    "student.year": "Which year are you in?",
    "student.year_ph": "e.g. 1st year, Master's, Erasmus…",
    "student.duration": "How long are you in Prague?",
    "student.duration_ph": "e.g. one semester, a year, staying put…",
    "student.notes": "Anything else you'd like to share?",
    "student.notes_ph": "Allergies, what you're hoping for, or just say hello",
    "student.submit": "Send it in",
    "student.sending": "Sending…",
    "student.success": "You're in! We'll be in touch really soon.",
    "student.toast": "We got your details, see you soon!",

    // Children's program registration
    "child.signup_title": "Join our children's program",
    "child.signup_desc": "Register your children for our Sunday Hebrew School. Add each child and we'll take care of the rest.",
    "child.signup_btn": "Register your child",
    "child.form_title": "Children's Program registration",
    "child.form_intro": "Tell us about you and your children. You can add as many children as you like.",
    "child.parent_section": "Parent / guardian details",
    "child.parent_name": "Full name",
    "child.parent_name_ph": "Parent or guardian name",
    "child.email": "Email",
    "child.email_ph": "you@example.com",
    "child.phone": "Phone",
    "child.phone_ph": "Best number to reach you",
    "child.phone2": "Second phone",
    "child.phone2_ph": "Optional — another contact number",
    "child.address": "Home address",
    "child.address_ph": "Street, city, postal code",
    "child.father": "Father",
    "child.mother": "Mother",
    "child.jewish_status": "Jewish status",
    "child.jewish_birth": "Jewish from birth",
    "child.jewish_conversion": "Jewish by conversion",
    "child.jewish_na": "Not Jewish / N/A",
    "child.conversion_doc": "Conversion document",
    "child.conversion_doc_hint": "PDF or photo · up to 10 MB",
    "child.upload_file": "Upload conversion document",
    "child.change_file": "Replace conversion document",
    "child.uploading": "Uploading…",
    "child.err_parents": "Please complete each parent's name, phone and Jewish status.",
    "child.err_conversion_doc": "Please upload the conversion document wherever 'Jewish by conversion' is selected.",
    "child.err_child_jewish": "Please select each child's Jewish status.",
    "child.children_section": "Children",
    "child.add_child": "Add another child",
    "child.child": "Child",
    "child.child_name": "Child's name",
    "child.child_name_ph": "First and last name",
    "child.dob": "Date of birth",
    "child.age": "Age",
    "child.gender": "Gender",
    "child.boy": "Boy",
    "child.girl": "Girl",
    "child.photo": "Photo",
    "child.photo_hint": "Optional — a recent photo of your child",
    "child.photo_change": "Change photo",
    "child.photo_add": "Upload photo",
    "child.uploading": "Uploading…",
    "child.allergies": "Allergies / medical notes",
    "child.allergies_ph": "Anything we should know",
    "child.grade": "School / grade",
    "child.grade_ph": "e.g. Grade 2, ZŠ Example",
    "child.program": "Which program?",
    "child.prog_sunday": "Sunday Hebrew School",
    "child.prog_thursday": "Thursday After School",
    "child.prog_both": "Both",
    "child.total": "Total",
    "child.free": "No payment required",
    "child.contribute": "Contribute",
    "child.without": "Register without contributing",
    "child.suggested_label": "Your contribution",
    "child.suggested_hint": "Optional — change the amount or register without contributing.",
    "child.suggested_note_default": "This program is offered on a suggested-participation basis. Contribute whatever works for your family.",
    "child.thursday_title": "Interested in Thursday After-School?",
    "child.thursday_note": "Our Thursday After-School program is available on request. Message us on WhatsApp and we'll be glad to share the details.",
    "child.thursday_cta": "Ask on WhatsApp",
    "child.photo_consent": "I give permission for photos and videos of my child(ren) taken during program activities to be used by Chabad of Prague on its website and social media.",
    "child.submit": "Submit registration",
    "child.pay": "Pay & register",
    "child.pay_paypal": "Pay with PayPal",
    "child.submitting": "Submitting…",
    "child.redirecting": "Redirecting…",
    "child.success_title": "Registration received!",
    "child.success_desc": "Thank you! Your registration is pending review. We'll confirm your child's spot by email shortly.",
    "child.pay_success": "Payment received — your registration is pending review.",
    "child.err_parent": "Please fill in your name and email.",
    "child.err_child": "Please give every child a name and pick a program.",


    // Events calendar
    "calendar.eyebrow": "Plan ahead",
    "calendar.title": "Monthly calendar",
    "calendar.today": "Today",
    "calendar.event": "Event",
    "calendar.note": "Note",
    "calendar.more": "more",
    "calendar.legend_event": "Events (with RSVP)",
    "calendar.legend_note": "Calendar notes",
    "calendar.general": "General",
    "calendar.no_entries": "Nothing on this day.",
    "calendar.view_event": "View event & RSVP",
    "student.required": "Please add at least your name and WhatsApp number.",

    // Holiday page
    "holidaypage.none": "No upcoming holidays yet",
    "holidaypage.backhome": "Back home",
    "holidaypage.events_suffix": "events",
    "holidaypage.events_title": "{name} events",
    "holidaypage.events_empty": "Events will be announced soon — check back or get in touch.",
    "holidaypage.get_ready": "Get Ready",
    "holidaypage.resources_for": "Resources for",
    "holidaypage.more": "More holidays",

    // Classes page
    "classespage.eyebrow": "Learn With Us",
    "classespage.title": "Weekly Classes",
    "classespage.desc": "Ongoing study, open to everyone. Join us in person — reach out on WhatsApp and we'll save you a seat.",
    "classespage.join_wa": "Join via WhatsApp",
    "classespage.none": "Classes will be announced soon.",
    "classespage.visit": "Visit us",

    // About page
    "about.eyebrow": "Who We Are",
    "about.title1": "A warm home,",
    "about.title2a": "built on",
    "about.title2b": "connection",
    "about.intro": "Our community was founded in 1996 out of a desire to create a living, connecting, and meaningful place for everyone. We operate year-round with weekly educational programs, community events, youth activities, classes, Shabbat gatherings, and holiday celebrations.",
    "about.story_eyebrow": "Our Story",
    "about.rebbe_attribution": "— The Lubavitcher Rebbe",
    "about.rebbe_alt": "The Lubavitcher Rebbe",
    "about.story_title": "From a small apartment to a thriving community",
    "about.story1": "In 1996, as emissaries of the Lubavitcher Rebbe, Rabbi Manis and Rebbetzin Dini arrived in Prague with a mission: to build a warm home for the city's Jews, travelers, students, and local families — a place of connection, meaning, and vibrant Jewish life.",
    "about.story2": "What began as a small, modest apartment quickly grew into a bustling community center — a place where Jews of every background, age, and style feel at home. Over the years, a truly unique community has formed, connecting people of all walks of life in a warm, open, and family-like atmosphere.",
    "about.story3": "In 2022, Rabbi Mendy and Mariashi joined the team, leading weekly activities for children, teens, and young adults, and founding a warm home for Jewish and Israeli students — with Shabbat meals, classes, events, and vibrant community life. In recent years, our Russian-speaking community has grown too, with Israel leading its activities so that everyone finds connection and belonging.",
    "about.val1_t": "A Home for Everyone",
    "about.val1_d": "No matter your background or level of observance, you belong here.",
    "about.val2_t": "Warmth & Care",
    "about.val2_d": "Every person is welcomed like family, with genuine care and open arms.",
    "about.val3_t": "Living Community",
    "about.val3_d": "Year-round programs, events, and gatherings that bring people together.",
    "about.val4_t": "Meaning & Joy",
    "about.val4_d": "Celebrating Jewish life, learning, and tradition with joy and purpose.",
    "about.staff_eyebrow": "Meet the Staff",
    "about.staff_title": "The people behind our community",
    "about.staff_desc": "A dedicated team devoted to making every person feel at home.",
    "about.cta_title": "Come be part of the family",
    "about.cta_desc": "Whether it's your first visit or your hundredth, there's always a seat at our table.",
    "about.cta_events": "See Upcoming Events",
    "about.cta_contact": "Get in Touch",

    // Kosher store page
    "kosher.eyebrow": "At Our Center",
    "kosher.default_title": "Kosher Food",
    "kosher.contact": "Contact the store on WhatsApp",
    "kosher.sales_title": "Current specials",
    "kosher.on_sale": "On sale",
    "kosher.empty": "New specials are coming soon — message us to ask what's in stock.",
    "kosher.back": "Back home",
  },
  he: {
    // Navbar
    "nav.home": "בית",
    "nav.programs": "תוכניות",
    "nav.events": "אירועים",
    "nav.holidays": "חגים",
    "nav.about": "אודות",
    "nav.gallery": "גלריה",
    "nav.services": "שירותים",
    "nav.contact": "צור קשר",
    "nav.donate": "תרומה",

    // Hero
    "hero.eyebrow": "פראג · קהילה",
    "hero.title1": "בית חם",
    "hero.title2a": "לכל",
    "hero.title2b": "לב יהודי",
    "hero.title3": "בפראג",
    "hero.subtitle": "מתוכניות לילדים ובר/בת מצווה ועד סעודות שבת, חגים, נוער ומועדון הסטודנטים שלנו — הצטרפו לקהילה שנבנתה על חום, מסורת ושמחה.",
    "hero.explore": "גלו את התוכניות",
    "hero.support": "האירועים הקרובים",
    "hero.about": "אודותינו",
    "hero.programs": "התוכניות שלנו",
    "hero.imgcap1": "פראג · מבט על",
    "hero.imgcap2": "כאן ממשיך הסיפור שלנו",
    "hero.scroll": "גללו",
    "hero.badge": "בית חם משנת 1996",

    // Programs
    "programs.eyebrow": "התוכניות שלנו",
    "programs.title": "משהו לכל שלב בחיים",
    "programs.desc": "שישה עמודי תווך של חיי הקהילה, שכל אחד מהם נועד לטפח חיבור, לימוד ותחושת שייכות.",

    // Holiday box
    "holiday.eyebrow": "החג הקרוב",
    "holiday.now_eyebrow": "חג שמח — עכשיו",
    "holiday.now": "עכשיו",
    "holiday.in_prefix": "בעוד",
    "holiday.day": "יום",
    "holiday.days": "ימים",
    "holiday.explore": "גלו את החג",

    // Stats
    "stats.eyebrow": "במספרים",
    "stats.title": "קהילה שמתחממת משנה לשנה",

    // Events
    "events.eyebrow": "מה קורה",
    "events.title": "אירועים קרובים",
    "events.desc": "הצטרפו אלינו לסעודות שבת, חגיגות חג ומפגשים קהילתיים.",
    "events.viewall": "לכל האירועים",
    "events.empty": "אין אירועים קרובים כרגע — חזרו לבקר בקרוב.",

    // Donate
    "donate.eyebrow": "תמכו בקהילה",
    "donate.title1": "התרומה שלכם משאירה את דלתותינו",
    "donate.title_italic": "פתוחות",
    "donate.desc": "כל תרומה מממנת סעודות שבת, חינוך ילדים, חגיגות חג ותמיכה בסטודנטים הרחוקים מהבית. במסורת היהודית, מתנה של ח\"י (18) נושאת ברכת חיים.",
    "donate.heart": "100% מגיע ישירות לתוכניות הקהילה",
    "donate.onetime": "חד פעמי",
    "donate.monthly": "חודשי",
    "donate.other": "אחר",
    "donate.name_ph": "השם שלכם (רשות)",
    "donate.email_ph": "האימייל שלכם (רשות)",
    "donate.button": "תרמו",
    "donate.permonth": "/חודש",
    "donate.redirecting": "מעביר…",
    "donate.secure": "תשלום מאובטח · Stripe & PayPal",
    "donate.secure_stripe": "תשלום מאובטח דרך Stripe",
    "donate.card": "תשלום בכרטיס",
    "donate.paypal": "תשלום דרך PayPal",
    "donate.or": "או",
    "donate.paypal_monthly_note": "PayPal מיועד לתרומות חד פעמיות. לתרומה חודשית השתמשו בכרטיס.",
    "donate.err_amount": "אנא בחרו סכום תרומה",
    "donate.err_checkout": "לא ניתן להתחיל את התשלום",

    // Gallery
    "gallery.eyebrow": "רגעים",
    "gallery.title": "החיים במרכז הקהילתי",
    "gallery.desc": "הצצה לחגיגות, ללימוד ולחברויות שהופכות אותנו למשפחה.",

    // Contact
    "contact.eyebrow": "צרו קשר",
    "contact.title": "נשמח לשמוע מכם",
    "contact.desc": "שאלות על תוכנית, רוצים לארח שבת, או פשוט להגיד שלום? פנו אלינו — הדלת שלנו תמיד פתוחה.",
    "contact.address": "העיר העתיקה, פראג, צ׳כיה",
    "contact.whatsapp": "420724300120",
    "contact.whatsapp_cta": "לחצו לשליחת הודעה",
    "contact.email": "hello@chabadprague.cz",
    "contact.phone": "+420 000 000 000",
    "contact.name": "שם",
    "contact.email": "אימייל",
    "contact.subject": "נושא",
    "contact.message": "הודעה",
    "contact.send": "שליחת הודעה",
    "contact.sending": "שולח…",
    "contact.success": "ההודעה נשלחה! ניצור קשר בקרוב.",
    "contact.error": "לא ניתן לשלוח את ההודעה",

    // Weekly strip
    "weekly.eyebrow": "מדי שבוע",
    "weekly.title": "מקום ללמוד, להתפלל ולהשתייך",
    "weekly.readmore": "פרטים והצטרפות",
    "weekly.ourshul": "בית הכנסת שלנו",
    "services.eyebrow": "שירותים קהילתיים",
    "services.title": "כאן בשביל הצרכים היומיומיים שלכם",
    "services.desc": "מעבר לתוכניות שלנו — השירותים שתומכים בחיים היהודיים בפראג, מאוכל כשר ועד בית הכנסת.",
    "services.serves": "שירות קהילתי",
    "services.viewall": "לכל השירותים",
    "services.order_whatsapp": "להזמנה בוואטסאפ",
    "services.contact_whatsapp": "צרו קשר לפרטים נוספים",
    "library.donate_title": "תרמו ספר, הגדילו את הספרייה",
    "library.donate_desc": "יש לכם ספר ילדים יהודי לתרומה? המתנה שלכם מרחיבה את המדפים — ואת קהל הקוראים הצעיר שלנו.",
    "library.donate_cta": "לתרומת ספר בוואטסאפ",
    "library.donate_msg": "שלום! אשמח לתרום ספר ילדים לספרייה.",
    "services.empty": "השירותים יופיעו כאן בקרוב.",
    "kosher_estab.eyebrow": "אוכל כשר",
    "kosher_estab.title": "מקומות כשרים",
    "kosher_estab.desc": "",
    "kosher_estab.address": "כתובת",
    "kosher_estab.hours": "שעות פתיחה",
    "kosher_estab.reserve": "הזמנות",
    "kosher_estab.group": "הזמנות קבוצתיות",
    "kosher_estab.map": "הצג במפה",
    "tourist.eyebrow": "דלפק תיירות",
    "tourist.title": "דלפק תיירות",
    "tourist.desc": "",
    "tourist.nolink": "קישור אתר התיירות עדיין לא נוסף.",
    "tourist.provide": "במה אנחנו עוזרים",
    "tourist.f1": "ארוחות שבת",
    "tourist.f2": "סיוע לתיירים בוואטסאפ",
    "tourist.f3": "המלצות למדריכי תיירים ומלונות",
    "tourist.f4": "בית כנסת",
    "tourist.f5": "מסעדות וחנות כשרות",
    "tourist.f6": "עזרה בחירום",
    "shul.prayer_times": "זמני תפילה",
    "shul.weekday": "ימי חול",
    "shul.shabbat": "שבת וחגים",

    // Footer
    "footer.tagline": "בית חם ומזמין לחיים יהודיים בלב פראג.",
    "footer.explore": "ניווט",
    "footer.about": "אודותינו",
    "footer.support": "תמיכה",
    "footer.admin": "ניהול",
    "footer.visit": "בקרו אותנו",
    "footer.address": "העיר העתיקה, פראג",
    "footer.country": "צ׳כיה",
    "footer.rights": "כל הזכויות שמורות.",
    "footer.built": "נבנה באהבה · פראג",

    // Events page
    "eventspage.eyebrow": "לוח אירועים",
    "eventspage.title": "מה מתרחש",
    "eventspage.desc": "הצטרפו אלינו. תמיד יש מקום סביב השולחן שלנו.",
    "eventspage.filter": "סינון:",
    "eventspage.all": "כל האירועים",
    "eventspage.none_title": "לא נמצאו אירועים",
    "eventspage.none_desc": "נסו לשנות את הסינון או חזרו לבקר בקרוב.",

    // Event detail
    "eventdetail.back": "כל האירועים",
    "eventdetail.past_title": "האירוע כבר התקיים",
    "eventdetail.past_desc": "ההרשמה סגורה. עיינו באירועים הקרובים שלנו כדי להצטרף בפעם הבאה.",
    "eventdetail.rsvp_closed_title": "ההרשמה הסתיימה",
    "eventdetail.sold_out_title": "מלא",
    "card.sold_out": "מלא",
    "eventdetail.notfound": "האירוע לא נמצא",
    "eventdetail.backto": "חזרה לאירועים",
    "eventdetail.loading": "טוען…",
    "eventdetail.time_tba": "שעה תפורסם",
    "eventdetail.default_loc": "בית חב\"ד פראג",
    "eventdetail.community": "קהילה",
    "eventdetail.loc_rsvp": "המיקום יימסר לאחר אישור הגעה",
    "eventdetail.about": "על האירוע",
    "eventdetail.rsvp_direct": "אישור הגעה ישיר",
    "eventdetail.rsvp_direct_desc": "כדי לשמור את מקומכם באירוע, שלחו לנו הודעה ישירות בוואטסאפ — נאשר את מקומכם ונשלח פרטים.",
    "eventdetail.rsvp_wa": "אישור הגעה בוואטסאפ",
    "eventdetail.no_rsvp_title": "אין צורך בהרשמה — כולם מוזמנים!",
    "eventdetail.no_rsvp_desc": "יש לכם שאלות? שלחו לנו הודעה בוואטסאפ לפרטים נוספים.",
    "eventdetail.no_rsvp_wa": "צרו קשר בוואטסאפ",
    "card.no_rsvp": "ללא צורך באישור הגעה",
    "card.students_only": "לסטודנטים בלבד",
    "eventdetail.students_title": "לסטודנטים בלבד",
    "eventdetail.students_desc": "האירוע פתוח לסטודנטים בלבד. שלחו לנו הודעה בוואטסאפ ונשלח לכם את הקישור הפרטי.",
    "eventdetail.students_wa": "צרו קשר בוואטסאפ",
    "card.students_cta": "צרו קשר לקבלת הקישור →",

    // Event card
    "card.view_rsvp": "צפייה ואישור הגעה",
    "card.view": "צפייה בפרטים",

    // RSVP form
    "rsvp.title": "שמרו את מקומכם",
    "rsvp.fullname": "שם מלא",
    "rsvp.email": "אימייל",
    "rsvp.phone": "טלפון (רשות)",
    "rsvp.guests": "אורחים",
    "rsvp.adults": "מבוגרים",
    "rsvp.children": "ילדים",
    "rsvp.each": "לאחד",
    "rsvp.confirm": "אישור הגעה",
    "rsvp.confirming": "מאשר…",
    "rsvp.done_title": "הכל מוכן!",
    "rsvp.done_desc": "אימייל אישור בדרך אליכם. אנחנו מחכים לראותכם.",
    "rsvp.success": "אישור ההגעה התקבל! בדקו את האימייל.",
    "rsvp.error": "לא ניתן לשלוח אישור הגעה",
    "rsvp.required": "נא למלא שדה זה",
    "rsvp.check_form": "נא להשלים את השדות המסומנים",
    "rsvp.per_person": "לאדם",
    "rsvp.family": "משפחה (מחיר קבוע)",
    "rsvp.ticket": "כרטיס",
    "rsvp.total": "סה\"כ",
    "rsvp.pay": "לתשלום",
    "rsvp.pay_rsvp": "ואישור הגעה",
    "rsvp.paywait": "מאמת את התשלום…",
    "rsvp.paid_toast": "התשלום התקבל — מקומכם נשמר! בדקו את האימייל.",
    "rsvp.pay_error": "לא ניתן לאמת את התשלום. אנא צרו קשר.",
    "rsvp.pending_title": "תודה — אתם ברשימה!",
    "rsvp.pending_desc": "אישור ההגעה שלכם ממתין לאישור המארגנים. נעדכן אתכם במייל ברגע שיאושר.",
    "rsvp.pending_toast": "אישור ההגעה התקבל — ממתין לאישור.",
    "rsvp.paid_pending_title": "הכרטיס אושר ✓",
    "rsvp.paid_pending_desc": "תודה! הכרטיס שלכם אושר אך לא חויב. אישור ההגעה ממתין כעת לאישור — החיוב יתבצע רק לאחר האישור, ונעדכן אתכם במייל.",
    "rsvp.paid_pending_toast": "הכרטיס אושר — החיוב יתבצע רק לאחר אישור ההגעה.",
    "rsvp.select_ph": "בחרו…",
    "rsvp.pay_card": "תשלום בכרטיס",
    "rsvp.paypal": "תשלום דרך PayPal",

    // Program detail
    "program.back": "כל התוכניות",
    "program.label": "תוכנית",
    "program.notfound": "התוכנית לא נמצאה",
    "program.backhome": "חזרה לבית",
    "program.explore_within": "גלו בתוך",
    "program.sub_active": "פעיל",
    "program.sub_inactive": "לא פעיל",
    "program.sub_next": "הבא",
    "program.sub_view_event": "לצפייה באירוע",
    "wa.title": "הצטרפו לקהילה שלנו",
    "wa.cta": "הצטרפו",
    "wa.desc": "קבלו עדכונים על אירועים והישארו מחוברים בוואטסאפ.",
    "wa.btn": "הצטרפו לקבוצת הוואטסאפ",
    "program.upcoming": "אירועי",
    "program.upcoming_suffix": "קרובים",
    "program.events_empty": "אין אירועים קרובים בתוכנית זו כרגע — חזרו לבקר בקרוב.",
    "program.past_events": "אירועים קודמים",
    "program.past_events_hide": "הסתר אירועים קודמים",
    "program.past_events_empty": "אין עדיין אירועים קודמים.",
    "program.memories": "זיכרונות",
    "program.flyers_eyebrow": "כדאי לדעת",
    "program.flyers_title": "עלונים ומידע",
    "program.past_photos": "תמונות מאירועים קודמים",
    "program.interested": "מתעניינים ב",
    "program.interested_q": "?",
    "program.cta_desc": "נשמח לקבל את פניכם. פנו אלינו ונעזור לכם להצטרף.",
    "program.get_in_touch": "צרו קשר",
    "program.stay_updated": "הישארו מעודכנים בוואטסאפ",

    // Students Club sign-up
    "student.signup_title": "חדשים בעיר? בואו להגיד שלום",
    "student.signup_desc": "לומדים בפראג? הצטרפו למועדון הסטודנטים — ארוחות, טיולים ואנשים טובים. השאירו פרטים ונחזור אליכם.",
    "student.signup_btn": "רשמו אותי",
    "student.form_title": "הצטרפו למועדון הסטודנטים",
    "student.form_intro": "רק כמה פרטים קצרים כדי שנכיר אתכם ונשאיר אתכם מעודכנים.",
    "student.name": "השם שלכם",
    "student.name_ph": "שם פרטי ומשפחה",
    "student.whatsapp": "מספר וואטסאפ",
    "student.whatsapp_ph": "כדי שנוכל להוסיף אתכם לקבוצה",
    "student.faculty": "מה אתם לומדים?",
    "student.faculty_ph": "פקולטה / אוניברסיטה",
    "student.year": "באיזו שנה אתם?",
    "student.year_ph": "לדוגמה: שנה א', תואר שני, אירסמוס…",
    "student.duration": "לכמה זמן אתם בפראג?",
    "student.duration_ph": "לדוגמה: סמסטר, שנה, נשארים לתמיד…",
    "student.notes": "עוד משהו שתרצו לשתף?",
    "student.notes_ph": "אלרגיות, למה אתם מצפים, או פשוט שלום",
    "student.submit": "שליחה",
    "student.sending": "שולח…",
    "student.success": "נרשמתם! נחזור אליכם ממש בקרוב.",
    "student.toast": "קיבלנו את הפרטים שלכם, נתראה בקרוב!",

    // Children's program registration
    "child.signup_title": "הצטרפו לתוכנית הילדים שלנו",
    "child.signup_desc": "רשמו את ילדיכם לבית הספר העברי בימי ראשון. הוסיפו כל ילד ואנחנו נדאג לשאר.",
    "child.signup_btn": "הרשמת ילד",
    "child.form_title": "הרשמה לתוכנית הילדים",
    "child.form_intro": "ספרו לנו עליכם ועל ילדיכם. אפשר להוסיף כמה ילדים שתרצו.",
    "child.parent_section": "פרטי הורה / אפוטרופוס",
    "child.parent_name": "שם מלא",
    "child.parent_name_ph": "שם ההורה או האפוטרופוס",
    "child.email": "אימייל",
    "child.email_ph": "you@example.com",
    "child.phone": "טלפון",
    "child.phone_ph": "המספר הטוב ביותר להשגה",
    "child.phone2": "טלפון נוסף",
    "child.phone2_ph": "רשות — מספר נוסף ליצירת קשר",
    "child.address": "כתובת מגורים",
    "child.address_ph": "רחוב, עיר, מיקוד",
    "child.father": "אבא",
    "child.mother": "אמא",
    "child.jewish_status": "סטטוס יהדות",
    "child.jewish_birth": "יהודי/ה מלידה",
    "child.jewish_conversion": "יהודי/ה מגיור",
    "child.jewish_na": "לא יהודי/ה / לא רלוונטי",
    "child.conversion_doc": "מסמך גיור",
    "child.conversion_doc_hint": "PDF או תמונה · עד 10 MB",
    "child.upload_file": "העלאת מסמך גיור",
    "child.change_file": "החלפת מסמך גיור",
    "child.uploading": "מעלה…",
    "child.err_parents": "נא למלא עבור כל הורה שם, טלפון וסטטוס יהדות.",
    "child.err_conversion_doc": "נא להעלות מסמך גיור בכל מקום שנבחר בו 'יהודי/ה מגיור'.",
    "child.err_child_jewish": "נא לבחור סטטוס יהדות עבור כל ילד.",
    "child.children_section": "ילדים",
    "child.add_child": "הוספת ילד נוסף",
    "child.child": "ילד",
    "child.child_name": "שם הילד",
    "child.child_name_ph": "שם פרטי ומשפחה",
    "child.dob": "תאריך לידה",
    "child.age": "גיל",
    "child.gender": "מין",
    "child.boy": "בן",
    "child.girl": "בת",
    "child.photo": "תמונה",
    "child.photo_hint": "רשות — תמונה עדכנית של הילד",
    "child.photo_change": "החלפת תמונה",
    "child.photo_add": "העלאת תמונה",
    "child.uploading": "מעלה…",
    "child.allergies": "אלרגיות / הערות רפואיות",
    "child.allergies_ph": "כל דבר שכדאי שנדע",
    "child.grade": "בית ספר / כיתה",
    "child.grade_ph": "לדוגמה: כיתה ב'",
    "child.program": "לאיזו תוכנית?",
    "child.prog_sunday": "בית ספר עברי - יום ראשון",
    "child.prog_thursday": "חוג אחר הצהריים - יום חמישי",
    "child.prog_both": "שתיהן",
    "child.total": "סך הכול",
    "child.free": "ללא תשלום",
    "child.contribute": "לתרום",
    "child.without": "הרשמה ללא תשלום",
    "child.suggested_label": "התרומה שלך",
    "child.suggested_hint": "רשות — ניתן לשנות את הסכום או להירשם ללא תשלום.",
    "child.suggested_note_default": "התוכנית מוצעת על בסיס השתתפות מומלצת. תרמו סכום שמתאים למשפחתכם.",
    "child.thursday_title": "מעוניינים בחוג אחר הצהריים בימי חמישי?",
    "child.thursday_note": "חוג אחר הצהריים בימי חמישי זמין לפי בקשה. שלחו לנו הודעה בוואטסאפ ונשמח לשתף בפרטים.",
    "child.thursday_cta": "שאלו בוואטסאפ",
    "child.photo_consent": "אני מאשר/ת שימוש בתמונות ובסרטונים של ילדיי שצולמו במהלך פעילויות התוכנית, על ידי בית חב\"ד פראג באתר וברשתות החברתיות.",
    "child.submit": "שליחת הרשמה",
    "child.pay": "תשלום והרשמה",
    "child.pay_paypal": "תשלום עם PayPal",
    "child.submitting": "שולח…",
    "child.redirecting": "מעביר…",
    "child.success_title": "ההרשמה התקבלה!",
    "child.success_desc": "תודה! ההרשמה ממתינה לאישור. נאשר את מקום ילדכם במייל בקרוב.",
    "child.pay_success": "התשלום התקבל — ההרשמה ממתינה לאישור.",
    "child.err_parent": "אנא מלאו שם ואימייל.",
    "child.err_child": "אנא הזינו שם ובחרו תוכנית לכל ילד.",


    // Events calendar
    "calendar.eyebrow": "תכננו מראש",
    "calendar.title": "לוח שנה חודשי",
    "calendar.today": "היום",
    "calendar.event": "אירוע",
    "calendar.note": "הערה",
    "calendar.more": "נוספים",
    "calendar.legend_event": "אירועים (עם הרשמה)",
    "calendar.legend_note": "הערות לוח שנה",
    "calendar.general": "כללי",
    "calendar.no_entries": "אין דבר ביום זה.",
    "calendar.view_event": "לצפייה באירוע והרשמה",
    "student.required": "אנא הוסיפו לפחות שם ומספר וואטסאפ.",

    // Holiday page
    "holidaypage.none": "אין עדיין חגים קרובים",
    "holidaypage.backhome": "חזרה לבית",
    "holidaypage.events_suffix": "אירועי",
    "holidaypage.events_title": "אירועי {name}",
    "holidaypage.events_empty": "אירועים יפורסמו בקרוב — חזרו לבקר או צרו קשר.",
    "holidaypage.get_ready": "התכוננו",
    "holidaypage.resources_for": "משאבים ל",
    "holidaypage.more": "עוד חגים",

    // Classes page
    "classespage.eyebrow": "למדו איתנו",
    "classespage.title": "שיעורים שבועיים",
    "classespage.desc": "לימוד מתמשך, פתוח לכולם. הצטרפו אלינו פנים אל פנים — פנו אלינו בוואטסאפ ונשמור לכם מקום.",
    "classespage.join_wa": "הצטרפו בוואטסאפ",
    "classespage.none": "השיעורים יפורסמו בקרוב.",
    "classespage.visit": "בקרו אותנו",

    // About page
    "about.eyebrow": "מי אנחנו",
    "about.title1": "בית חם,",
    "about.title2a": "הבנוי על",
    "about.title2b": "חיבור",
    "about.intro": "הקהילה שלנו נוסדה בשנת 1996 מתוך רצון ליצור מקום חי, מחבר ומשמעותי לכולם. אנו פועלים כל השנה עם תוכניות חינוכיות שבועיות, אירועים קהילתיים, פעילויות נוער, שיעורים, מפגשי שבת וחגיגות חג.",
    "about.story_eyebrow": "הסיפור שלנו",
    "about.rebbe_attribution": "— הרבי מליובאוויטש",
    "about.rebbe_alt": "הרבי מליובאוויטש",
    "about.story_title": "מדירה קטנה לקהילה משגשגת",
    "about.story1": "בשנת 1996, כשליחי הרבי מליובאוויטש, הרב מאניס והרבנית דיני הגיעו לפראג עם שליחות: לבנות בית חם ליהודי העיר, למטיילים, לסטודנטים ולמשפחות המקומיות — מקום של חיבור, משמעות וחיים יהודיים תוססים.",
    "about.story2": "מה שהחל כדירה קטנה וצנועה הפך במהרה למרכז קהילתי שוקק — מקום שבו יהודים מכל רקע, גיל וסגנון מרגישים בבית. עם השנים נוצרה קהילה ייחודית באמת, המחברת אנשים מכל תחומי החיים באווירה חמה, פתוחה ומשפחתית.",
    "about.story3": "בשנת 2022 הצטרפו לצוות הרב מנדי ומריאשי, המובילים פעילויות שבועיות לילדים, לנוער ולצעירים, ומקימים בית חם לסטודנטים יהודים וישראלים — עם סעודות שבת, שיעורים, אירועים וחיי קהילה תוססים. בשנים האחרונות גדלה גם הקהילה דוברת הרוסית שלנו, כשישראל מוביל את פעילותה כדי שכולם ימצאו חיבור ושייכות.",
    "about.val1_t": "בית לכולם",
    "about.val1_d": "לא משנה הרקע או רמת השמירה שלכם, כאן מקומכם.",
    "about.val2_t": "חום ואכפתיות",
    "about.val2_d": "כל אדם מתקבל כמו משפחה, באכפתיות אמיתית ובזרועות פתוחות.",
    "about.val3_t": "קהילה חיה",
    "about.val3_d": "תוכניות, אירועים ומפגשים לאורך כל השנה שמקרבים בין אנשים.",
    "about.val4_t": "משמעות ושמחה",
    "about.val4_d": "חוגגים חיים יהודיים, לימוד ומסורת מתוך שמחה ומטרה.",
    "about.staff_eyebrow": "הכירו את הצוות",
    "about.staff_title": "האנשים שמאחורי הקהילה",
    "about.staff_desc": "צוות מסור שמחויב לגרום לכל אדם להרגיש בבית.",
    "about.cta_title": "בואו להיות חלק מהמשפחה",
    "about.cta_desc": "בין אם זו ביקורכם הראשון או המאה, תמיד יש מקום סביב השולחן שלנו.",
    "about.cta_events": "לאירועים הקרובים",
    "about.cta_contact": "צרו קשר",

    // Kosher store page
    "kosher.eyebrow": "במרכז שלנו",
    "kosher.default_title": "אוכל כשר",
    "kosher.contact": "צרו קשר עם החנות בוואטסאפ",
    "kosher.sales_title": "מבצעים נוכחיים",
    "kosher.on_sale": "במבצע",
    "kosher.empty": "מבצעים חדשים בקרוב — שלחו לנו הודעה לבירור מה קיים במלאי.",
    "kosher.back": "חזרה לבית",
  },
  ru: {
    // Navbar
    "nav.home": "Главная",
    "nav.programs": "Программы",
    "nav.events": "События",
    "nav.holidays": "Праздники",
    "nav.about": "О нас",
    "nav.gallery": "Галерея",
    "nav.services": "Услуги",
    "nav.contact": "Контакты",
    "nav.donate": "Пожертвовать",

    // Hero
    "hero.eyebrow": "Прага · Община",
    "hero.title1": "Тёплый дом",
    "hero.title2a": "для каждого",
    "hero.title2b": "еврейского",
    "hero.title3": "сердца в Праге",
    "hero.subtitle": "От детских программ и бар/бат-мицвы до субботних трапез, праздников, молодёжи и нашего студенческого клуба — присоединяйтесь к общине, построенной на теплоте, традиции и радости.",
    "hero.explore": "Наши программы",
    "hero.support": "Предстоящие события",
    "hero.about": "О нас",
    "hero.programs": "Наши программы",
    "hero.imgcap1": "Прага · С высоты",
    "hero.imgcap2": "Здесь продолжается наша история",
    "hero.scroll": "Прокрутите",
    "hero.badge": "Тёплый дом с 1996 года",

    // Programs
    "programs.eyebrow": "Наши программы",
    "programs.title": "Что-то для каждого этапа жизни",
    "programs.desc": "Шесть опор общинной жизни, каждая из которых призвана развивать связь, учёбу и чувство принадлежности.",

    // Holiday box
    "holiday.eyebrow": "Ближайший праздник",
    "holiday.now_eyebrow": "Сейчас праздник",
    "holiday.now": "Сейчас",
    "holiday.in_prefix": "Через",
    "holiday.day": "день",
    "holiday.days": "дн.",
    "holiday.explore": "Узнать о празднике",

    // Stats
    "stats.eyebrow": "В цифрах",
    "stats.title": "Община, что теплеет с каждым годом",

    // Events
    "events.eyebrow": "Афиша",
    "events.title": "Ближайшие события",
    "events.desc": "Присоединяйтесь к субботним ужинам, празднованиям и общинным встречам.",
    "events.viewall": "Все события",
    "events.empty": "Сейчас нет ближайших событий — загляните позже.",

    // Donate
    "donate.eyebrow": "Поддержите общину",
    "donate.title1": "Ваш дар держит наши двери",
    "donate.title_italic": "открытыми",
    "donate.desc": "Каждое пожертвование поддерживает субботние трапезы, обучение детей, празднования и помощь студентам вдали от дома. В еврейской традиции дар «хай» (18) несёт благословение жизни.",
    "donate.heart": "100% идёт напрямую на программы общины",
    "donate.onetime": "Разово",
    "donate.monthly": "Ежемесячно",
    "donate.other": "Другое",
    "donate.name_ph": "Ваше имя (необязательно)",
    "donate.email_ph": "Ваш email (необязательно)",
    "donate.button": "Пожертвовать",
    "donate.permonth": "/мес",
    "donate.redirecting": "Переход…",
    "donate.secure": "Безопасная оплата · Stripe & PayPal",
    "donate.secure_stripe": "Безопасная оплата через Stripe",
    "donate.card": "Оплатить картой",
    "donate.paypal": "Оплатить через PayPal",
    "donate.or": "или",
    "donate.paypal_monthly_note": "PayPal — для разовых пожертвований. Для ежемесячных используйте карту.",
    "donate.err_amount": "Пожалуйста, выберите сумму пожертвования",
    "donate.err_checkout": "Не удалось начать оплату",

    // Gallery
    "gallery.eyebrow": "Моменты",
    "gallery.title": "Жизнь в общине",
    "gallery.desc": "Взгляд на празднования, учёбу и дружбу, что делают нас семьёй.",

    // Contact
    "contact.eyebrow": "Связаться с нами",
    "contact.title": "Будем рады услышать вас",
    "contact.desc": "Вопросы о программе, хотите провести шаббат или просто поздороваться? Напишите нам — наши двери всегда открыты.",
    "contact.address": "Старый город, Прага, Чехия",
    "contact.whatsapp": "420724300120",
    "contact.whatsapp_cta": "Написать нам в WhatsApp",
    "contact.email": "hello@chabadprague.cz",
    "contact.phone": "+420 000 000 000",
    "contact.name": "Имя",
    "contact.email": "Email",
    "contact.subject": "Тема",
    "contact.message": "Сообщение",
    "contact.send": "Отправить",
    "contact.sending": "Отправка…",
    "contact.success": "Сообщение отправлено! Скоро свяжемся с вами.",
    "contact.error": "Не удалось отправить сообщение",

    // Weekly strip
    "weekly.eyebrow": "Каждую неделю",
    "weekly.title": "Место, чтобы учиться, молиться и быть своим",
    "weekly.readmore": "Подробнее и записаться",
    "weekly.ourshul": "Наша синагога",
    "services.eyebrow": "Услуги для общины",
    "services.title": "Мы рядом для ваших повседневных нужд",
    "services.desc": "Помимо наших программ — услуги, поддерживающие еврейскую жизнь в Праге, от кошерной еды до синагоги.",
    "services.serves": "Услуга для общины",
    "services.viewall": "Все услуги",
    "services.order_whatsapp": "Заказать в WhatsApp",
    "services.contact_whatsapp": "Связаться для подробностей",
    "library.donate_title": "Подарите книгу — пусть библиотека растёт",
    "library.donate_desc": "Есть еврейская детская книга, которой хотите поделиться? Ваш подарок пополнит наши полки и порадует юных читателей.",
    "library.donate_cta": "Подарить книгу через WhatsApp",
    "library.donate_msg": "Здравствуйте! Хочу подарить детскую книгу для библиотеки.",
    "services.empty": "Услуги скоро появятся здесь.",
    "kosher_estab.eyebrow": "Кошерная еда",
    "kosher_estab.title": "Кошерные заведения",
    "kosher_estab.desc": "",
    "kosher_estab.address": "Адрес",
    "kosher_estab.hours": "Часы работы",
    "kosher_estab.reserve": "Бронирование",
    "kosher_estab.group": "Групповые заказы",
    "kosher_estab.map": "Показать на карте",
    "tourist.eyebrow": "Туристический стол",
    "tourist.title": "Туристический стол",
    "tourist.desc": "",
    "tourist.nolink": "Ссылка на туристический сайт ещё не добавлена.",
    "tourist.provide": "Чем мы помогаем",
    "tourist.f1": "Субботние трапезы",
    "tourist.f2": "Помощь туристам в WhatsApp",
    "tourist.f3": "Рекомендации гидов и отелей",
    "tourist.f4": "Синагога",
    "tourist.f5": "Кошерные рестораны и магазин",
    "tourist.f6": "Экстренная помощь",
    "shul.prayer_times": "Время молитв",
    "shul.weekday": "Будни",
    "shul.shabbat": "Шаббат и праздники",

    // Footer
    "footer.tagline": "Тёплый, гостеприимный дом еврейской жизни в самом сердце Праги.",
    "footer.explore": "Разделы",
    "footer.about": "О нас",
    "footer.support": "Поддержка",
    "footer.admin": "Админ",
    "footer.visit": "Приходите",
    "footer.address": "Старый город, Прага",
    "footer.country": "Чехия",
    "footer.rights": "Все права защищены.",
    "footer.built": "Сделано с теплом · Прага",

    // Events page
    "eventspage.eyebrow": "Календарь событий",

    // Children's program registration
    "child.signup_title": "Запишитесь в нашу детскую программу",
    "child.signup_desc": "Запишите детей в нашу воскресную еврейскую школу. Добавьте каждого ребёнка — остальное мы возьмём на себя.",
    "child.signup_btn": "Записать ребёнка",
    "child.form_title": "Регистрация в детскую программу",
    "child.form_intro": "Расскажите о себе и о детях. Можно добавить сколько угодно детей.",
    "child.parent_section": "Данные родителя / опекуна",
    "child.parent_name": "Полное имя",
    "child.parent_name_ph": "Имя родителя или опекуна",
    "child.email": "Эл. почта",
    "child.email_ph": "you@example.com",
    "child.phone": "Телефон",
    "child.phone_ph": "Удобный номер для связи",
    "child.phone2": "Второй телефон",
    "child.phone2_ph": "Необязательно — ещё один контакт",
    "child.address": "Домашний адрес",
    "child.address_ph": "Улица, город, индекс",
    "child.father": "Отец",
    "child.mother": "Мать",
    "child.jewish_status": "Еврейский статус",
    "child.jewish_birth": "Еврей(ка) по рождению",
    "child.jewish_conversion": "Еврей(ка) по гиюру",
    "child.jewish_na": "Не еврей / Не применимо",
    "child.conversion_doc": "Документ о гиюре",
    "child.conversion_doc_hint": "PDF или фото · до 10 МБ",
    "child.upload_file": "Загрузить документ о гиюре",
    "child.change_file": "Заменить документ о гиюре",
    "child.uploading": "Загрузка…",
    "child.err_parents": "Пожалуйста, укажите имя, телефон и еврейский статус каждого родителя.",
    "child.err_conversion_doc": "Пожалуйста, загрузите документ о гиюре везде, где выбрано «Еврей(ка) по гиюру».",
    "child.err_child_jewish": "Пожалуйста, выберите еврейский статус каждого ребёнка.",
    "child.children_section": "Дети",
    "child.add_child": "Добавить ещё ребёнка",
    "child.child": "Ребёнок",
    "child.child_name": "Имя ребёнка",
    "child.child_name_ph": "Имя и фамилия",
    "child.dob": "Дата рождения",
    "child.age": "Возраст",
    "child.gender": "Пол",
    "child.boy": "Мальчик",
    "child.girl": "Девочка",
    "child.photo": "Фото",
    "child.photo_hint": "Необязательно — недавнее фото ребёнка",
    "child.photo_change": "Изменить фото",
    "child.photo_add": "Загрузить фото",
    "child.uploading": "Загрузка…",
    "child.allergies": "Аллергии / медицинские заметки",
    "child.allergies_ph": "Что нам следует знать",
    "child.grade": "Школа / класс",
    "child.grade_ph": "например, 2 класс",
    "child.program": "Какая программа?",
    "child.prog_sunday": "Воскресная еврейская школа",
    "child.prog_thursday": "Четверг, после школы",
    "child.prog_both": "Обе",
    "child.total": "Итого",
    "child.free": "Оплата не требуется",
    "child.contribute": "Внести вклад",
    "child.without": "Зарегистрироваться без взноса",
    "child.suggested_label": "Ваш вклад",
    "child.suggested_hint": "Необязательно — измените сумму или зарегистрируйтесь без взноса.",
    "child.suggested_note_default": "Программа предлагается на основе рекомендуемого участия. Внесите сумму, удобную для вашей семьи.",
    "child.thursday_title": "Интересует программа по четвергам после школы?",
    "child.thursday_note": "Четверговая программа после школы доступна по запросу. Напишите нам в WhatsApp — мы с радостью расскажем подробности.",
    "child.thursday_cta": "Спросить в WhatsApp",
    "child.photo_consent": "Я разрешаю использование фотографий и видео моего ребёнка (детей), сделанных во время программных мероприятий, организацией Хабад Праги на сайте и в социальных сетях.",
    "child.submit": "Отправить регистрацию",
    "child.pay": "Оплатить и записать",
    "child.pay_paypal": "Оплатить через PayPal",
    "child.submitting": "Отправка…",
    "child.redirecting": "Перенаправление…",
    "child.success_title": "Регистрация получена!",
    "child.success_desc": "Спасибо! Регистрация ожидает подтверждения. Мы сообщим о месте вашего ребёнка по электронной почте.",
    "child.pay_success": "Оплата получена — регистрация ожидает подтверждения.",
    "child.err_parent": "Пожалуйста, укажите имя и эл. почту.",
    "child.err_child": "Укажите имя и выберите программу для каждого ребёнка.",

    "eventspage.title": "Что происходит",
    "eventspage.desc": "Присоединяйтесь. За нашим столом всегда найдётся место.",
    "eventspage.filter": "Фильтр:",
    "eventspage.all": "Все события",
    "eventspage.none_title": "События не найдены",
    "eventspage.none_desc": "Измените фильтр или загляните позже.",

    // Event detail
    "eventdetail.back": "Все события",
    "eventdetail.past_title": "Это событие уже прошло",
    "eventdetail.past_desc": "Регистрация закрыта. Посмотрите наши предстоящие события, чтобы присоединиться в следующий раз.",
    "eventdetail.rsvp_closed_title": "Регистрация закрыта",
    "eventdetail.sold_out_title": "Мест нет",
    "card.sold_out": "Мест нет",
    "eventdetail.notfound": "Событие не найдено",
    "eventdetail.backto": "К событиям",
    "eventdetail.loading": "Загрузка…",
    "eventdetail.time_tba": "Время уточняется",
    "eventdetail.default_loc": "Хабад Прага",
    "eventdetail.community": "Община",
    "eventdetail.loc_rsvp": "Адрес сообщим после регистрации",
    "eventdetail.about": "Об этом событии",
    "eventdetail.rsvp_direct": "Прямая регистрация",
    "eventdetail.rsvp_direct_desc": "Чтобы забронировать место, напишите нам напрямую в WhatsApp — мы подтвердим место и сообщим детали.",
    "eventdetail.rsvp_wa": "Регистрация в WhatsApp",
    "eventdetail.no_rsvp_title": "Регистрация не требуется — приглашаем всех!",
    "eventdetail.no_rsvp_desc": "Есть вопросы? Напишите нам в WhatsApp — расскажем подробнее.",
    "eventdetail.no_rsvp_wa": "Написать в WhatsApp",
    "card.no_rsvp": "Без регистрации",
    "card.students_only": "Только для студентов",
    "eventdetail.students_title": "Только для студентов",
    "eventdetail.students_desc": "Это мероприятие только для студентов. Напишите нам в WhatsApp, и мы отправим вам личную ссылку для доступа.",
    "eventdetail.students_wa": "Написать в WhatsApp",
    "card.students_cta": "Свяжитесь с нами для ссылки →",

    // Event card
    "card.view_rsvp": "Подробнее и запись",
    "card.view": "Подробнее",

    // RSVP form
    "rsvp.title": "Забронируйте место",
    "rsvp.fullname": "Полное имя",
    "rsvp.email": "Email",
    "rsvp.phone": "Телефон (необязательно)",
    "rsvp.guests": "Гости",
    "rsvp.adults": "Взрослые",
    "rsvp.children": "Дети",
    "rsvp.each": "за чел.",
    "rsvp.confirm": "Подтвердить",
    "rsvp.confirming": "Подтверждение…",
    "rsvp.done_title": "Всё готово!",
    "rsvp.done_desc": "Письмо с подтверждением уже в пути. Ждём встречи с вами.",
    "rsvp.success": "Регистрация подтверждена! Проверьте почту.",
    "rsvp.error": "Не удалось отправить регистрацию",
    "rsvp.required": "Пожалуйста, заполните это поле",
    "rsvp.check_form": "Пожалуйста, заполните выделенные поля",
    "rsvp.per_person": "За человека",
    "rsvp.family": "Семья (фикс. цена)",
    "rsvp.ticket": "Билет",
    "rsvp.total": "Итого",
    "rsvp.pay": "Оплатить",
    "rsvp.pay_rsvp": "и записаться",
    "rsvp.paywait": "Проверяем оплату…",
    "rsvp.paid_toast": "Оплата получена — вы записаны! Проверьте почту.",
    "rsvp.pay_error": "Не удалось подтвердить оплату. Свяжитесь с нами.",
    "rsvp.pending_title": "Спасибо — вы в списке!",
    "rsvp.pending_desc": "Ваша регистрация ожидает подтверждения. Мы напишем вам, как только она будет одобрена.",
    "rsvp.pending_toast": "Регистрация получена — ожидает подтверждения.",
    "rsvp.paid_pending_title": "Карта авторизована ✓",
    "rsvp.paid_pending_desc": "Спасибо! Ваша карта авторизована, но не списана. Регистрация ожидает подтверждения — деньги спишутся только после одобрения, и мы напишем вам.",
    "rsvp.paid_pending_toast": "Карта авторизована — списание только после подтверждения регистрации.",
    "rsvp.select_ph": "Выберите…",
    "rsvp.pay_card": "Оплатить картой",
    "rsvp.paypal": "Оплатить через PayPal",

    // Program detail
    "program.back": "Все программы",
    "program.label": "Программа",
    "program.notfound": "Программа не найдена",
    "program.backhome": "На главную",
    "program.explore_within": "Внутри программы",
    "program.sub_active": "Активно",
    "program.sub_inactive": "Неактивно",
    "program.sub_next": "Ближайшее",
    "program.sub_view_event": "Открыть событие",
    "wa.title": "Присоединяйтесь к нашей общине",
    "wa.cta": "Вступить",
    "wa.desc": "Получайте новости о событиях и оставайтесь на связи в WhatsApp.",
    "wa.btn": "Вступить в группу WhatsApp",
    "program.upcoming": "Ближайшие события",
    "program.upcoming_suffix": "",
    "program.events_empty": "Сейчас нет ближайших событий в этой программе — загляните позже.",
    "program.past_events": "Прошедшие события",
    "program.past_events_hide": "Скрыть прошедшие события",
    "program.past_events_empty": "Пока нет прошедших событий.",
    "program.memories": "Воспоминания",
    "program.flyers_eyebrow": "Полезно знать",
    "program.flyers_title": "Флаеры и информация",
    "program.past_photos": "Фото с прошлых событий",
    "program.interested": "Интересует",
    "program.interested_q": "?",
    "program.cta_desc": "Будем рады видеть вас. Напишите нам, и мы поможем присоединиться.",
    "program.get_in_touch": "Связаться",
    "program.stay_updated": "Будьте в курсе в WhatsApp",

    // Students Club sign-up
    "student.signup_title": "Недавно в городе? Заходите познакомиться",
    "student.signup_desc": "Учитесь в Праге? Присоединяйтесь к Студенческому клубу — ужины, поездки и хорошие люди. Оставьте данные, и мы свяжемся с вами.",
    "student.signup_btn": "Записать меня",
    "student.form_title": "Присоединиться к Студенческому клубу",
    "student.form_intro": "Всего пара вопросов, чтобы познакомиться и держать вас в курсе.",
    "student.name": "Ваше имя",
    "student.name_ph": "Имя и фамилия",
    "student.whatsapp": "Номер WhatsApp",
    "student.whatsapp_ph": "Чтобы добавить вас в группу",
    "student.faculty": "Что вы изучаете?",
    "student.faculty_ph": "Факультет / университет",
    "student.year": "На каком вы курсе?",
    "student.year_ph": "напр. 1 курс, магистратура, Эразмус…",
    "student.duration": "Как долго вы в Праге?",
    "student.duration_ph": "напр. один семестр, год, остаюсь надолго…",
    "student.notes": "Хотите что-то добавить?",
    "student.notes_ph": "Аллергии, ожидания или просто привет",
    "student.submit": "Отправить",
    "student.sending": "Отправка…",
    "student.success": "Готово! Мы скоро свяжемся с вами.",
    "student.toast": "Мы получили ваши данные, до скорой встречи!",

    // Events calendar
    "calendar.eyebrow": "Планируйте заранее",
    "calendar.title": "Календарь на месяц",
    "calendar.today": "Сегодня",
    "calendar.event": "Событие",
    "calendar.note": "Заметка",
    "calendar.more": "ещё",
    "calendar.legend_event": "События (с регистрацией)",
    "calendar.legend_note": "Заметки календаря",
    "calendar.general": "Общее",
    "calendar.no_entries": "В этот день ничего нет.",
    "calendar.view_event": "Открыть событие и регистрацию",
    "student.required": "Пожалуйста, укажите хотя бы имя и номер WhatsApp.",

    // Holiday page
    "holidaypage.none": "Пока нет ближайших праздников",
    "holidaypage.backhome": "На главную",
    "holidaypage.events_suffix": "— события",
    "holidaypage.events_title": "События · {name}",
    "holidaypage.events_empty": "События будут объявлены скоро — загляните позже или свяжитесь с нами.",
    "holidaypage.get_ready": "Подготовьтесь",
    "holidaypage.resources_for": "Материалы для",
    "holidaypage.more": "Другие праздники",

    // Classes page
    "classespage.eyebrow": "Учитесь с нами",
    "classespage.title": "Еженедельные занятия",
    "classespage.desc": "Постоянная учёба, открытая для всех. Присоединяйтесь лично — напишите в WhatsApp, и мы сохраним вам место.",
    "classespage.join_wa": "Записаться в WhatsApp",
    "classespage.none": "Занятия будут объявлены скоро.",
    "classespage.visit": "Приходите",

    // About page
    "about.eyebrow": "Кто мы",
    "about.title1": "Тёплый дом,",
    "about.title2a": "построенный на",
    "about.title2b": "связи",
    "about.intro": "Наша община основана в 1996 году из желания создать живое, объединяющее и осмысленное место для каждого. Мы работаем круглый год: еженедельные образовательные программы, общинные события, молодёжные занятия, уроки, субботние встречи и празднования праздников.",
    "about.story_eyebrow": "Наша история",
    "about.rebbe_attribution": "— Любавичский Ребе",
    "about.rebbe_alt": "Любавичский Ребе",
    "about.story_title": "От маленькой квартиры до процветающей общины",
    "about.story1": "В 1996 году, как посланники Любавичского Ребе, раввин Манис и ребецин Дини прибыли в Прагу с миссией: построить тёплый дом для евреев города, путешественников, студентов и местных семей — место связи, смысла и яркой еврейской жизни.",
    "about.story2": "То, что начиналось как маленькая скромная квартира, быстро выросло в оживлённый общинный центр — место, где евреи любого происхождения, возраста и стиля чувствуют себя как дома. За годы сложилась поистине уникальная община, объединяющая людей из всех сфер жизни в тёплой, открытой и семейной атмосфере.",
    "about.story3": "В 2022 году к команде присоединились раввин Менди и Мариаши, ведущие еженедельные занятия для детей, подростков и молодёжи и основавшие тёплый дом для еврейских и израильских студентов — с субботними трапезами, уроками, событиями и яркой общинной жизнью. В последние годы выросла и наша русскоязычная община, деятельность которой ведёт Исраэль, чтобы каждый нашёл связь и принадлежность.",
    "about.val1_t": "Дом для каждого",
    "about.val1_d": "Независимо от происхождения или уровня соблюдения — здесь ваше место.",
    "about.val2_t": "Тепло и забота",
    "about.val2_d": "Каждого встречают как семью, с искренней заботой и открытыми объятиями.",
    "about.val3_t": "Живая община",
    "about.val3_d": "Программы, события и встречи круглый год, что объединяют людей.",
    "about.val4_t": "Смысл и радость",
    "about.val4_d": "Мы празднуем еврейскую жизнь, учёбу и традицию с радостью и смыслом.",
    "about.staff_eyebrow": "Наша команда",
    "about.staff_title": "Люди, стоящие за нашей общиной",
    "about.staff_desc": "Преданная команда, посвятившая себя тому, чтобы каждый чувствовал себя как дома.",
    "about.cta_title": "Станьте частью семьи",
    "about.cta_desc": "Первый это визит или сотый — за нашим столом всегда есть место для вас.",
    "about.cta_events": "Ближайшие события",
    "about.cta_contact": "Связаться",

    // Kosher store page
    "kosher.eyebrow": "В нашем центре",
    "kosher.default_title": "Кошерная еда",
    "kosher.contact": "Связаться с магазином в WhatsApp",
    "kosher.sales_title": "Текущие предложения",
    "kosher.on_sale": "Акция",
    "kosher.empty": "Скоро новые предложения — напишите нам, чтобы узнать, что есть в наличии.",
    "kosher.back": "На главную",
  },
  cs: {
    "nav.home": "Domů",
    "nav.programs": "Programy",
    "nav.events": "Akce",
    "nav.holidays": "Svátky",
    "nav.about": "O nás",
    "nav.gallery": "Galerie",
    "nav.services": "Služby",
    "nav.contact": "Kontakt",
    "nav.donate": "Darovat",
    "hero.eyebrow": "Praha · Zavedená komunita",
    "hero.title1": "Vřelý domov",
    "hero.title2a": "pro každé",
    "hero.title2b": "židovské",
    "hero.title3": "srdce v Praze",
    "hero.subtitle": "Od dětských programů a Bar/Bat micvy přes šabatové večeře, svátky, teen programy až po náš studentský klub — přidejte se ke komunitě postavené na vřelosti, tradici a radosti.",
    "hero.explore": "Prozkoumat programy",
    "hero.support": "Nejbližší akce",
    "hero.about": "O nás",
    "hero.programs": "Naše programy",
    "hero.imgcap1": "Praha · z ptačí perspektivy",
    "hero.imgcap2": "Místo, kde náš příběh pokračuje",
    "hero.scroll": "Posunout",
    "hero.badge": "Vřelý domov od roku 1996",
    "programs.eyebrow": "Naše programy",
    "programs.title": "Něco pro každou etapu života",
    "programs.desc": "Šest pilířů komunitního života, z nichž každý je navržen tak, aby podporoval propojení, vzdělávání a sounáležitost.",
    "holiday.eyebrow": "Nejbližší svátek",
    "holiday.now_eyebrow": "Právě probíhá",
    "holiday.now": "Nyní",
    "holiday.in_prefix": "Za",
    "holiday.day": "den",
    "holiday.days": "dny",
    "holiday.explore": "Prozkoumat svátek",
    "stats.eyebrow": "Čísla v kostce",
    "stats.title": "Komunita, která každým rokem hřeje víc",
    "events.eyebrow": "Co se děje",
    "events.title": "Nadcházející akce",
    "events.desc": "Přidejte se k nám na šabatové večeře, oslavy svátků a komunitní setkání.",
    "events.viewall": "Zobrazit všechny akce",
    "events.empty": "Momentálně nejsou žádné nadcházející akce — brzy se sem vraťte.",
    "donate.eyebrow": "Podpořte komunitu",
    "donate.title1": "Váš dar udržuje naše dveře",
    "donate.title_italic": "otevřené",
    "donate.desc": "Každý dar podporuje šabatová jídla, vzdělávání dětí, sváteční oslavy i pomoc studentům daleko od domova. V židovské tradici nesou dary chai (18) požehnání života.",
    "donate.heart": "100 % jde přímo na komunitní programy",
    "donate.onetime": "Jednorázově",
    "donate.monthly": "Měsíčně",
    "donate.other": "Jiná částka",
    "donate.name_ph": "Vaše jméno (nepovinné)",
    "donate.email_ph": "Váš e-mail (nepovinné)",
    "donate.button": "Přispět",
    "donate.permonth": "/měs.",
    "donate.redirecting": "Přesměrování…",
    "donate.secure": "Bezpečná platba · Stripe & PayPal",
    "donate.secure_stripe": "Bezpečná platba přes Stripe",
    "donate.card": "Zaplatit kartou",
    "donate.paypal": "Zaplatit přes PayPal",
    "donate.or": "nebo",
    "donate.paypal_monthly_note": "PayPal je určen pro jednorázové dary. Pro měsíční podporu prosím použijte kartu.",
    "donate.err_amount": "Vyberte prosím částku daru",
    "donate.err_checkout": "Nepodařilo se zahájit platbu",
    "gallery.eyebrow": "Okamžiky",
    "gallery.title": "Život v centru",
    "gallery.desc": "Ukázka oslav, učení a přátelství, díky nimž jsme jako rodina.",
    "contact.eyebrow": "Ozvěte se nám",
    "contact.title": "Budeme rádi, když se ozvete",
    "contact.desc": "Máte otázky k programu, chcete uspořádat šabat, nebo jen pozdravit? Napište nám — naše dveře jsou vždy otevřené.",
    "contact.address": "Staré Město, Praha, Česká republika",
    "contact.whatsapp": "420724300120",
    "contact.whatsapp_cta": "Klikněte a napište nám",
    "contact.email": "E-mail",
    "contact.phone": "+420 000 000 000",
    "contact.name": "Jméno",
    "contact.subject": "Předmět",
    "contact.message": "Zpráva",
    "contact.send": "Odeslat zprávu",
    "contact.sending": "Odesílání…",
    "contact.success": "Zpráva odeslána! Brzy se vám ozveme.",
    "contact.error": "Nepodařilo se odeslat zprávu",
    "weekly.eyebrow": "Každý týden",
    "weekly.title": "Místo pro učení, modlitbu a sounáležitost",
    "weekly.readmore": "Více informací a připojte se",
    "weekly.ourshul": "Naše synagoga",
    "services.eyebrow": "Služby pro komunitu",
    "services.title": "Jsme tu pro vaše každodenní potřeby",
    "services.desc": "Kromě našich programů také služby, které podporují židovský život v Praze — od košer jídla až po naši synagogu.",
    "services.serves": "Služba pro komunitu",
    "services.viewall": "Zobrazit všechny služby",
    "services.order_whatsapp": "Objednat přes WhatsApp",
    "services.contact_whatsapp": "Kontaktujte nás pro více informací",
    "library.donate_title": "Darujte knihu, rozšiřte knihovnu",
    "library.donate_desc": "Máte židovskou dětskou knihu, o kterou se chcete podělit? Váš dar pomůže růst našim regálům — i našim mladým čtenářům.",
    "library.donate_cta": "Darujte knihu přes WhatsApp",
    "library.donate_msg": "Dobrý den! Rád/a bych daroval/a do knihovny dětskou knihu.",
    "services.empty": "Služby se zde brzy zobrazí.",
    "kosher_estab.eyebrow": "Košer stravování",
    "kosher_estab.title": "Košer podniky",
    "kosher_estab.desc": "",
    "kosher_estab.address": "Adresa",
    "kosher_estab.hours": "Otevírací doba",
    "kosher_estab.reserve": "Rezervace",
    "kosher_estab.group": "Skupinové rezervace",
    "kosher_estab.map": "Zobrazit na mapě",
    "tourist.eyebrow": "Turistická přepážka",
    "tourist.title": "Turistická přepážka",
    "tourist.desc": "",
    "tourist.nolink": "Odkaz na turistický web zatím nebyl přidán.",
    "tourist.provide": "S čím pomáháme",
    "tourist.f1": "Šabatová jídla",
    "tourist.f2": "Turistická pomoc přes WhatsApp",
    "tourist.f3": "Průvodce a doporučení hotelů",
    "tourist.f4": "Synagoga",
    "tourist.f5": "Košer restaurace a obchod",
    "tourist.f6": "Nouzová pomoc",
    "shul.prayer_times": "Časy modliteb",
    "shul.weekday": "Ve všední dny",
    "shul.shabbat": "Šabat a svátky",
    "footer.tagline": "Vřelý a přívětivý domov pro židovský život v srdci Prahy.",
    "footer.explore": "Prozkoumat",
    "footer.about": "O nás",
    "footer.support": "Podpora",
    "footer.admin": "Administrace",
    "footer.visit": "Navštivte nás",
    "footer.address": "Staré Město, Praha",
    "footer.country": "Česká republika",
    "footer.rights": "Všechna práva vyhrazena.",
    "footer.built": "Vytvořeno s vřelostí · Praha",
    "eventspage.eyebrow": "Kalendář akcí",
    "eventspage.title": "Co se děje",
    "eventspage.desc": "Přijďte mezi nás. U našeho stolu je vždy jedno místo pro vás.",
    "eventspage.filter": "Filtr:",
    "eventspage.all": "Všechny akce",
    "eventspage.none_title": "Žádné akce nebyly nalezeny",
    "eventspage.none_desc": "Zkuste upravit filtry nebo se brzy vraťte.",
    "eventdetail.back": "Všechny akce",
    "eventdetail.past_title": "Tato akce už proběhla",
    "eventdetail.past_desc": "RSVP je uzavřeno. Prohlédněte si naše nadcházející akce a přijďte příště s námi.",
    "eventdetail.rsvp_closed_title": "Rezervace jsou uzavřené",
    "eventdetail.sold_out_title": "Obsazeno",
    "card.sold_out": "Obsazeno",
    "eventdetail.notfound": "Akce nenalezena",
    "eventdetail.backto": "Zpět na akce",
    "eventdetail.loading": "Načítání…",
    "eventdetail.time_tba": "Čas bude upřesněn",
    "eventdetail.default_loc": "Chabad v Praze",
    "eventdetail.community": "Komunita",
    "eventdetail.loc_rsvp": "Místo sdělíme po potvrzení účasti",
    "eventdetail.about": "O této akci",
    "eventdetail.rsvp_direct": "Potvrdit účast přímo",
    "eventdetail.rsvp_direct_desc": "Chcete-li si rezervovat místo na této akci, napište nám prosím přímo na WhatsApp — potvrdíme vám účast a pošleme veškeré podrobnosti.",
    "eventdetail.rsvp_wa": "Potvrdit účast na WhatsAppu",
    "eventdetail.no_rsvp_title": "Rezervace není nutná — všichni jsou vítáni!",
    "eventdetail.no_rsvp_desc": "Napište nám na WhatsApp, pokud máte jakékoli dotazy nebo chcete více informací.",
    "eventdetail.no_rsvp_wa": "Kontaktujte nás na WhatsAppu",
    "card.no_rsvp": "Není nutné potvrzení účasti",
    "card.students_only": "Pouze pro studenty",
    "eventdetail.students_title": "Pouze pro studenty",
    "eventdetail.students_desc": "Tato akce je určena pouze pro studenty. Napište nám na WhatsApp a pošleme vám soukromý odkaz pro vstup.",
    "eventdetail.students_wa": "Kontaktujte nás na WhatsAppu",
    "card.students_cta": "Napište nám pro odkaz →",
    "card.view_rsvp": "Zobrazit a přihlásit se",
    "card.view": "Zobrazit detaily",
    "rsvp.title": "Rezervujte si své místo",
    "rsvp.fullname": "Celé jméno",
    "rsvp.email": "E-mail",
    "rsvp.phone": "Telefon (volitelné)",
    "rsvp.guests": "Hosté",
    "rsvp.adults": "Dospělí",
    "rsvp.children": "Děti",
    "rsvp.each": "za osobu",
    "rsvp.confirm": "Potvrdit přihlášení",
    "rsvp.confirming": "Potvrzujeme…",
    "rsvp.done_title": "Vše je připraveno!",
    "rsvp.done_desc": "Potvrzovací e-mail je na cestě. Už se na vás těšíme.",
    "rsvp.success": "Přihlášení potvrzeno! Zkontrolujte svůj e-mail.",
    "rsvp.error": "Přihlášení se nepodařilo odeslat",
    "rsvp.required": "Prosíme, vyplňte toto pole",
    "rsvp.check_form": "Prosíme, doplňte zvýrazněná pole",
    "rsvp.per_person": "Za osobu",
    "rsvp.family": "Rodina (paušální cena)",
    "rsvp.ticket": "Vstupenka",
    "rsvp.total": "Celkem",
    "rsvp.pay": "Zaplatit",
    "rsvp.pay_rsvp": "& přihlásit se",
    "rsvp.paywait": "Potvrzujeme vaši platbu…",
    "rsvp.paid_toast": "Platba byla přijata — vaše účast je potvrzena! Zkontrolujte svůj e-mail.",
    "rsvp.pay_error": "Platbu se nepodařilo ověřit. Kontaktujte nás prosím.",
    "rsvp.pending_title": "Děkujeme — jste na seznamu!",
    "rsvp.pending_desc": "Vaše přihlášení RSVP čeká na schválení. Jakmile bude potvrzeno, pošleme vám e-mail.",
    "rsvp.pending_toast": "RSVP přijato — čeká na schválení.",
    "rsvp.paid_pending_title": "Karta autorizována ✓",
    "rsvp.paid_pending_desc": "Děkujeme! Vaše karta byla autorizována, ale zatím nebyla stržena. Vaše přihlášení RSVP nyní čeká na schválení — platba bude stržena až po potvrzení a dáme vám vědět e-mailem.",
    "rsvp.paid_pending_toast": "Karta autorizována — platba bude stržena až po schválení vašeho RSVP.",
    "rsvp.select_ph": "Vyberte…",
    "rsvp.pay_card": "Zaplatit kartou",
    "rsvp.paypal": "Zaplatit přes PayPal",
    "program.back": "Všechny programy",
    "program.label": "Program",
    "program.notfound": "Program nenalezen",
    "program.backhome": "Zpět na domovskou stránku",
    "program.explore_within": "Prozkoumat v rámci",
    "program.sub_active": "Aktivní",
    "program.sub_inactive": "Neaktivní",
    "program.sub_next": "Další",
    "program.sub_view_event": "Zobrazit událost",
    "wa.title": "Připojte se k naší komunitě",
    "wa.cta": "Připojit se",
    "wa.desc": "Získejte aktualizace o akcích a zůstaňte s námi ve spojení na WhatsAppu.",
    "wa.btn": "Připojit se ke skupině WhatsApp",
    "program.upcoming": "Nadcházející",
    "program.upcoming_suffix": "akce",
    "program.events_empty": "Momentálně v tomto programu nejsou žádné nadcházející akce — brzy se podívejte znovu.",
    "program.past_events": "Minulé akce",
    "program.past_events_hide": "Skrýt minulé akce",
    "program.past_events_empty": "Zatím žádné minulé akce.",
    "program.memories": "Vzpomínky",
    "program.flyers_eyebrow": "Dobré vědět",
    "program.flyers_title": "Letáky a informace",
    "program.past_photos": "Fotografie z minulých akcí",
    "program.interested": "Máte zájem o",
    "program.interested_q": "?",
    "program.cta_desc": "Rádi vás přivítáme. Ozvěte se a my vám pomůžeme zapojit se.",
    "program.get_in_touch": "Ozvěte se nám",
    "program.stay_updated": "Sledujte novinky na WhatsAppu",
    "student.signup_title": "Noví ve městě? Přijďte se pozdravit",
    "student.signup_desc": "Studujete v Praze? Přidejte se do Studentského klubu — večeře, výlety a skvělí lidé. Zanechte nám své údaje a ozveme se vám.",
    "student.signup_btn": "Zapište mě",
    "student.form_title": "Připojte se ke Studentskému klubu",
    "student.form_intro": "Stačí pár rychlých informací, abychom vás mohli lépe poznat a udržet s vámi kontakt.",
    "student.name": "Vaše jméno",
    "student.name_ph": "Jméno a příjmení",
    "student.whatsapp": "WhatsApp číslo",
    "student.whatsapp_ph": "Abychom vás mohli přidat do skupiny",
    "student.faculty": "Co studujete?",
    "student.faculty_ph": "Fakulta / univerzita",
    "student.year": "Ve kterém ročníku jste?",
    "student.year_ph": "např. 1. ročník, magistr, Erasmus…",
    "student.duration": "Jak dlouho budete v Praze?",
    "student.duration_ph": "např. jeden semestr, rok, na delší dobu…",
    "student.notes": "Je ještě něco, co byste chtěli sdílet?",
    "student.notes_ph": "Alergie, co očekáváte, nebo jen pozdrav",
    "student.submit": "Odeslat",
    "student.sending": "Odesílání…",
    "student.success": "Jste tam! Brzy se vám ozveme.",
    "student.toast": "Vaše údaje jsme obdrželi, brzy na viděnou!",
    "child.signup_title": "Připojte své děti k našemu programu",
    "child.signup_desc": "Zaregistrujte své děti do naší nedělní hebrejské školy. Přidejte každé dítě a o zbytek se postaráme.",
    "child.signup_btn": "Zaregistrovat dítě",
    "child.form_title": "Registrace do dětského programu",
    "child.form_intro": "Napište nám něco o sobě a svých dětech. Můžete přidat libovolný počet dětí.",
    "child.parent_section": "Údaje o rodiči / zákonném zástupci",
    "child.parent_name": "Celé jméno",
    "child.parent_name_ph": "Jméno rodiče nebo zákonného zástupce",
    "child.email": "E-mail",
    "child.email_ph": "vy@example.com",
    "child.phone": "Telefon",
    "child.phone_ph": "Nejlepší číslo, na kterém vás zastihneme",
    "child.phone2": "Druhý telefon",
    "child.phone2_ph": "Nepovinné — další kontaktní číslo",
    "child.address": "Adresa bydliště",
    "child.address_ph": "Ulice, město, PSČ",
    "child.father": "Otec",
    "child.mother": "Matka",
    "child.jewish_status": "Židovský status",
    "child.jewish_birth": "Židov/Židovka od narození",
    "child.jewish_conversion": "Žid/Židovka konverzí",
    "child.jewish_na": "Nejsem Žid/Židovka / netýká se",
    "child.conversion_doc": "Doklad o konverzi",
    "child.conversion_doc_hint": "PDF nebo fotografie · až 10 MB",
    "child.upload_file": "Nahrát doklad o konverzi",
    "child.change_file": "Nahradit doklad o konverzi",
    "child.uploading": "Nahrávání…",
    "child.err_parents": "Vyplňte prosím jméno, telefon a židovský status u každého rodiče.",
    "child.err_conversion_doc": "Nahrajte prosím doklad o konverzi všude, kde je zvoleno „Žid/Židovka konverzí“.",
    "child.err_child_jewish": "Vyberte prosím židovský status u každého dítěte.",
    "child.children_section": "Děti",
    "child.add_child": "Přidat další dítě",
    "child.child": "Dítě",
    "child.child_name": "Jméno dítěte",
    "child.child_name_ph": "Jméno a příjmení",
    "child.dob": "Datum narození",
    "child.age": "Věk",
    "child.gender": "Pohlaví",
    "child.boy": "Chlapec",
    "child.girl": "Dívka",
    "child.photo": "Fotografie",
    "child.photo_hint": "Volitelné — nedávná fotografie vašeho dítěte",
    "child.photo_change": "Změnit fotografii",
    "child.photo_add": "Nahrát fotografii",
    "child.allergies": "Alergie / zdravotní poznámky",
    "child.allergies_ph": "Cokoli, co bychom měli vědět",
    "child.grade": "Škola / ročník",
    "child.grade_ph": "např. 2. třída, ZŠ Ukázková",
    "child.program": "Do kterého programu?",
    "child.prog_sunday": "Nedělní hebrejská škola",
    "child.prog_thursday": "Čtvrteční družina",
    "child.prog_both": "Oba",
    "child.total": "Celkem",
    "child.free": "Nejsou vyžadovány žádné platby",
    "child.contribute": "Přispět",
    "child.without": "Zaregistrovat se bez příspěvku",
    "child.suggested_label": "Váš příspěvek",
    "child.suggested_hint": "Volitelné — můžete změnit částku nebo se zaregistrovat bez příspěvku.",
    "child.suggested_note_default": "Tento program je nabízen na základě doporučeného příspěvku. Přispějte částkou, která je pro vaši rodinu vhodná.",
    "child.thursday_title": "Máte zájem o čtvrteční odpolední program?",
    "child.thursday_note": "Náš čtvrteční odpolední program je k dispozici na vyžádání. Napište nám na WhatsApp a rádi vám sdělíme podrobnosti.",
    "child.thursday_cta": "Zeptat se na WhatsApp",
    "child.photo_consent": "Dávám svolení, aby fotografie a videa mých dětí pořízené během programu mohly být Chabad of Prague použity na jeho webových stránkách a sociálních sítích.",
    "child.submit": "Odeslat registraci",
    "child.pay": "Zaplatit a zaregistrovat",
    "child.pay_paypal": "Zaplatit přes PayPal",
    "child.submitting": "Odesílání…",
    "child.redirecting": "Přesměrování…",
    "child.success_title": "Registrace přijata!",
    "child.success_desc": "Děkujeme! Vaše registrace čeká na schválení. Brzy potvrdíme místo pro vaše dítě e-mailem.",
    "child.pay_success": "Platba přijata — vaše registrace čeká na schválení.",
    "child.err_parent": "Vyplňte prosím své jméno a e-mail.",
    "child.err_child": "U každého dítěte prosím uveďte jméno a vyberte program.",
    "calendar.eyebrow": "Plánujte s předstihem",
    "calendar.title": "Měsíční kalendář",
    "calendar.today": "Dnes",
    "calendar.event": "Událost",
    "calendar.note": "Poznámka",
    "calendar.more": "další",
    "calendar.legend_event": "Události (s RSVP)",
    "calendar.legend_note": "Poznámky v kalendáři",
    "calendar.general": "Obecné",
    "calendar.no_entries": "V tento den nic není.",
    "calendar.view_event": "Zobrazit událost a RSVP",
    "student.required": "Prosím, přidejte alespoň své jméno a číslo WhatsApp.",
    "holidaypage.none": "Zatím nejsou žádné nadcházející svátky",
    "holidaypage.backhome": "Zpět domů",
    "holidaypage.events_suffix": "události",
    "holidaypage.events_title": "Události {name}",
    "holidaypage.events_empty": "Události budou brzy oznámeny — vraťte se sem později nebo nás kontaktujte.",
    "holidaypage.get_ready": "Připravte se",
    "holidaypage.resources_for": "Materiály pro",
    "holidaypage.more": "Další svátky",
    "classespage.eyebrow": "Učte se s námi",
    "classespage.title": "Týdenní kurzy",
    "classespage.desc": "Průběžné studium otevřené všem. Přijďte osobně — ozvěte se nám na WhatsApp a my vám schováme místo.",
    "classespage.join_wa": "Připojit se přes WhatsApp",
    "classespage.none": "Kurzy budou brzy oznámeny.",
    "classespage.visit": "Navštivte nás",
    "about.eyebrow": "Kdo jsme",
    "about.title1": "Vřelý domov,",
    "about.title2a": "postavený na",
    "about.title2b": "spojení",
    "about.intro": "Naše komunita byla založena v roce 1996 z touhy vytvořit živé, propojené a smysluplné místo pro každého. Fungujeme celoročně s týdenními vzdělávacími programy, komunitními akcemi, aktivitami pro mládež, kurzy, setkáními na Šabat a svátečními oslavami.",
    "about.story_eyebrow": "Náš příběh",
    "about.rebbe_attribution": "— Lubavičský Rebbe",
    "about.rebbe_alt": "Lubavičský Rebbe",
    "about.story_title": "Od malého bytu k prosperující komunitě",
    "about.story1": "V roce 1996, jako vyslanci Lubavičského Rebbeho, dorazili do Prahy rabín Manis a rebecen Dini s posláním: vybudovat vřelý domov pro židy města, cestovatele, studenty i místní rodiny — místo spojení, smyslu a živého židovského života.",
    "about.story2": "To, co začalo jako malý, skromný byt, se brzy proměnilo v rušné komunitní centrum — místo, kde se všichni Židé bez ohledu na původ, věk či styl cítí jako doma. V průběhu let vznikla skutečně jedinečná komunita, která v přátelské, otevřené a rodinné atmosféře propojuje lidi ze všech oblastí života.",
    "about.story3": "V roce 2022 se k týmu připojili rabín Mendy a Mariashi, kteří vedou týdenní aktivity pro děti, teenagery i mladé dospělé, a založili vřelý domov pro židovské a izraelské studenty — se šabatovými večeřemi, kurzy, akcemi a živým komunitním životem. V posledních letech také rostla naše ruskojazyčná komunita, s níž pracuje Israel, aby si každý našel spojení a pocit sounáležitosti.",
    "about.val1_t": "Domov pro každého",
    "about.val1_d": "Bez ohledu na váš původ nebo úroveň dodržování jste zde vítáni.",
    "about.val2_t": "Vřelost a péče",
    "about.val2_d": "Každý je přijímán jako člen rodiny, s opravdovou péčí a otevřenou náručí.",
    "about.val3_t": "Živá komunita",
    "about.val3_d": "Celoroční programy, akce a setkání, která lidi spojují.",
    "about.val4_t": "Smysl a radost",
    "about.val4_d": "S radostí a cílem oslavujeme židovský život, učení a tradici.",
    "about.staff_eyebrow": "Seznamte se s týmem",
    "about.staff_title": "Lidé, kteří stojí za naší komunitou",
    "about.staff_desc": "Oddaný tým, který se věnuje tomu, aby se u nás každý cítil jako doma.",
    "about.cta_title": "Přijďte se stát součástí rodiny",
    "about.cta_desc": "Ať už jste u nás poprvé, nebo po stopadesáté, u našeho stolu je pro vás vždycky místo.",
    "about.cta_events": "Podívejte se na nadcházející akce",
    "about.cta_contact": "Ozvěte se nám",
    "kosher.eyebrow": "U nás v centru",
    "kosher.default_title": "Košer jídlo",
    "kosher.contact": "Kontaktujte obchod přes WhatsApp",
    "kosher.sales_title": "Aktuální nabídky",
    "kosher.on_sale": "Ve slevě",
    "kosher.empty": "Nové akční nabídky brzy přijdou — napište nám a zeptejte se, co je skladem.",
    "kosher.back": "Zpět domů",
  },
};

export function localize(item, field, lang) {
  if (!item) return "";
  if (lang !== "en" && item.i18n && item.i18n[lang] && item.i18n[lang][field]) {
    return item.i18n[lang][field];
  }
  return item[field] ?? "";
}
